import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { PermissionService } from '../../../service/permission/permission.service';
import { Permission } from '../../../class/permission';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss']
})
export class PermissionComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoPermission: Permission;
    public permission: Permission;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public permissionService: PermissionService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelPermission () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/permissions/permission/permission.component.ts